import { Address } from '@cdaas/api-clients/dist/asset-user-openapi';
import { COUNTRIES, VERIFY_EMAIL_PATTERN, VERIFY_PHONE_NUMBER_PATTERN } from '@cdaas/reusable-components-daas';

export const isValidEmail = (email: string | null = ''): boolean => VERIFY_EMAIL_PATTERN.test(email ?? '');

// From 4 to 12 digit - can be tuned!
export const isValidPhoneNumber = (phoneNumber: string | null = ''): boolean => VERIFY_PHONE_NUMBER_PATTERN.test(phoneNumber ?? '');

export const isValidPhoneNumberWithCountryCallingCode = (phoneNumber = ''): boolean => {
  const acceptedCountryCallingCodes = COUNTRIES.map(countryCallingCode => `+${countryCallingCode.code}`);
  const startsWithAcceptedCountryCallingCode = acceptedCountryCallingCodes.find(countryCallingCode => phoneNumber.startsWith(countryCallingCode));
  if (!startsWithAcceptedCountryCallingCode) {
    return false;
  }
  const restOfTheNumber = phoneNumber.substring(startsWithAcceptedCountryCallingCode.length);
  return isValidPhoneNumber(restOfTheNumber);
};

export const takeValidAddress = (
  delivery?: Address | null,
  billing?: Address | null,
  preferred: 'delivery' | 'billing' = 'delivery',
): Address | undefined => {
  let deliveryValid;
  let billingValid;

  if (delivery) {
    if (delivery.street && delivery.zip && delivery.city && delivery.country) {
      deliveryValid = true;
    }
  }

  if (billing) {
    if (billing.street && billing.zip && billing.city && billing.country) {
      billingValid = true;
    }
  }

  if (preferred === 'delivery') {
    return deliveryValid ? delivery! : billingValid ? billing! : undefined;
  } else if (preferred === 'billing') {
    return billingValid ? billing! : deliveryValid ? delivery! : undefined;
  }
};

// Requirement for PIM: whitespace surrounding employee ID should be omitted
export const sanitizeEmployeeId = (employeeId: string | null | undefined): string | null => employeeId?.trim() || null;

export const hasAddressRequiredFields = (address?: Address) => !!(address?.street && address?.country && address?.city && address?.zip);
